import axios from 'axios'
import authHeader from '../../module/auth-header'
import { uriConstants } from '../constants'

export const authService = {
  logIn,
  logInCorp,
  logOut,
  getCurrentUser,

  /**간편로그인 */
  passLogin,
  // pinEmptyYn,
  pinNumReset,

  /**카카오로그인 */
  passkakaoLogin,
  mobileKakaoLogin,

  /**네이버로그인 */
  passnaverLogin,
  mobileNaverLogin,

  /**공동인증서 로그인 */
  passcrtfctLogin,
  passcrtfctLoginIos,

  passonepassLogin,

  qrLoginCheck,

  simplLogin,
}

async function logIn(userName, password) {
  password = encodeURIComponent(password)
  return await axios.post(uriConstants.API_URI + uriConstants.SIGN_IN, 'userId=' + userName + '&password=' + password)
  
  // return await axios.post(
    //   process.env.REACT_APP_API_URL + '/login',
    //   {
      //     userName: userName,
      //     password: password
      //   }
      // )
    }
    
async function logInCorp(userName, password) {
  password = encodeURIComponent(password)
  return await axios.post(uriConstants.API_URI + uriConstants.SIGN_IN_CORP, 'userId=' + userName + '&password=' + password)

  // return await axios.post(
  //   process.env.REACT_APP_API_URL + '/login',
  //   {
  //     userName: userName,
  //     password: password
  //   }
  // )
}
async function passLogin(pinNum, deviceId) {
  return await axios.post(uriConstants.API_URI + uriConstants.PASS_SIGN_IN, 'pinNum=' + pinNum + '&deviceId=' + deviceId)
}

// 핀번호 (재)설정
async function pinNumReset(pinNum, deviceId) {
  return await axios.post(uriConstants.API_URI + uriConstants.PIN_RESET, 'pinNum=' + pinNum + '&deviceId=' + deviceId)
}

// // 핀번호 설정여부 확인
// async function pinEmptyYn(deviceId) {
//   return await axios.post(
//       uriConstants.API_URI + uriConstants.PIN_EMPTY_YN,
//     'deviceId=' + deviceId
//   )
// }

async function passkakaoLogin(params) {
  return await axios.post(uriConstants.API_URI + uriConstants.ADD_KAKAO_LOGIN, 'code=' + params)
}
async function mobileKakaoLogin(params) {
  return await axios.post(uriConstants.API_URI + uriConstants.M_KAKAO_LOGIN, 'snsId=' + params)
}

async function passnaverLogin(params, state) {
  return await axios.post(uriConstants.API_URI + uriConstants.ADD_NAVER_LOGIN, 'code=' + params + '&state=' + state)
}

async function mobileNaverLogin(params, state) {
  return await axios.post(uriConstants.API_URI + uriConstants.M_NAVER_LOGIN, 'snsId=' + params)
}

async function passcrtfctLogin(params, gbn, mobileYn) {
  return await axios.post(
    uriConstants.API_URI + uriConstants.LOGIN_CRTFCT_INFO,
    'loginData=' + encodeURIComponent(params) + '&gbn=' + gbn + '&mobileYn=' + mobileYn,
  )
}

async function passcrtfctLoginIos(params, gbn, mobileYn) {
  return await axios.post(
    uriConstants.API_URI + uriConstants.LOGIN_CRTFCT_INFO_IOS,
    'loginData=' + encodeURIComponent(params) + '&gbn=' + gbn +'&certVerifyType=2'+ '&mobileYn=' + mobileYn,
  )
}

async function passonepassLogin(params) {
  return await axios.post(uriConstants.API_URI + uriConstants.ADD_ONEPASS_LOGIN, 'memberId=' + params)
}

async function qrLoginCheck(params) {
  return await axios.post(uriConstants.API_URI + uriConstants.QR_LOGIN, 'ranNum=' + params)
}

async function simplLogin(params) {
  return await axios.post(uriConstants.API_URI + uriConstants.SIMPLE_LOGIN, 'memberId=' + params)
}

async function getCurrentUser() {
  return localStorage.getItem('user')
}

async function logOut() {
  return localStorage.removeItem('user')
}
